import {
  BUYERS_ACTIVITY_TRACK_TYPE,
  BuyersActivityTrackType,
} from 'models/Lead';

export const EVENT_TYPES = Object.values(BUYERS_ACTIVITY_TRACK_TYPE);

export const EVENT_TYPES_DATA_ROOM_FIRST = [
  BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM,
  BUYERS_ACTIVITY_TRACK_TYPE.PLATFORM,
  BUYERS_ACTIVITY_TRACK_TYPE.NOTIFICATION,
];

export const EVENT_TYPE_TITLE_COPY: Record<BuyersActivityTrackType, string> = {
  [BUYERS_ACTIVITY_TRACK_TYPE.PLATFORM]: 'platformEvents',
  [BUYERS_ACTIVITY_TRACK_TYPE.NOTIFICATION]: 'notificationEvents',
  [BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM]: 'dataRoomEvents',
};

export const EVENT_TYPE_TOOLTIP_COPY: Record<BuyersActivityTrackType, string> =
  {
    [BUYERS_ACTIVITY_TRACK_TYPE.PLATFORM]: 'platformEventsTooltip',
    [BUYERS_ACTIVITY_TRACK_TYPE.NOTIFICATION]: 'notificationEventsTooltip',
    [BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM]: 'dataRoomEventsTooltip',
  };
